import { useEffect } from 'react';
import clsx from 'clsx';
import { useMemo, useRef, useState } from 'react';
import { useMeasure } from 'react-use';
import { useLocale } from '../../store/i18nMessage';
import { SearchDialog } from './SearchDialog';
import { TooltipProvider } from '@radix-ui/react-tooltip';

import styles from './index.module.scss';

export type Web3SearchProps = {
  className?: string;
};

export function Web3Search({ className }: Web3SearchProps) {
  const [setSearchMeasureRef, { width }] = useMeasure<HTMLDivElement>();
  const searchRef = useRef<HTMLDivElement>();
  const showInput = width >= 144;
  const [showSearchDialog, setShowSearchDialog] = useState(false);
  const { t } = useLocale();

  const dlgLeft = useMemo(() => `${searchRef.current?.offsetLeft}px`, [searchRef.current]);

  return (
    <>
      <div
        ref={(ele) => {
          if (!ele) return;
          searchRef.current = ele;
          setSearchMeasureRef(ele);
        }}
        className={clsx(styles.container, className)}
      >
        <div className={showInput ? styles.searchLong : styles.searchIcon} onClick={(e) => setShowSearchDialog(true)}>
          <div className={clsx('svg-full', showInput ? 'w-4 h-4' : 'w-6 h-6')}>{searchIcon}</div>
          <span>{t('searchCoin')}</span>
        </div>
      </div>
      <TooltipProvider delayDuration={0}>
        {showSearchDialog && (
          <SearchDialog
            visible={showSearchDialog}
            left={dlgLeft}
            onClose={() => {
              setShowSearchDialog(false);
            }}
          />
        )}
      </TooltipProvider>
    </>
  );
}

const searchIcon = (
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <path d="M14.264 24.527c2.277-0 4.489-0.763 6.283-2.166l5.64 5.64 1.814-1.814-5.64-5.64c1.404-1.794 2.166-4.006 2.167-6.284 0-5.659-4.604-10.264-10.263-10.264s-10.264 4.604-10.264 10.264c0 5.659 4.604 10.263 10.264 10.263zM14.264 6.566c4.245 0 7.698 3.452 7.698 7.698s-3.452 7.698-7.698 7.698c-4.245 0-7.698-3.452-7.698-7.698s3.452-7.698 7.698-7.698z"></path>
  </svg>
);
